export var formStyles = {
  root: function root(_ref) {
    var props = _ref.props,
        v = _ref.variables;
    return {
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-evenly',
      justifyItems: 'start',
      '> *:not(:last-child)': {
        marginBottom: v.fieldsMarginBottom
      },
      '> :last-child': {
        marginTop: v.lastChildMarginTop
      }
    };
  }
};
//# sourceMappingURL=formStyles.js.map
